import { IComponentOptions } from "angular";
import { MachinesSoftwareUpgradeViewController } from "./controller";

export const vsComponentName = "machinesSoftwareUpgradeView";

export const MachinesSoftwareUpgradeViewComponentOptions: IComponentOptions = {
  controller: MachinesSoftwareUpgradeViewController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    model: "<",
  },
};
